(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-an-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-an-carousel-track]');
  const dotsWrap = carousel.querySelector('[data-an-carousel-dots]');
  if (!track || !dotsWrap) return;
  const cards = Array.from(track.children);
  if (!cards.length) return;

  function getPages() {
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
    const cardWidth = cards[0].getBoundingClientRect().width + gap;
    if (!cardWidth) return 1;
    const perView = Math.max(1, Math.round(track.clientWidth / cardWidth));
    const rows = Math.max(1, parseInt(getComputedStyle(track).getPropertyValue('--rows'), 10) || 1);
    const perPage = perView * rows;
    return Math.max(1, Math.ceil(cards.length / perPage));
  }

  function scrollToPage(index, pages) {
    const maxScroll = track.scrollWidth - track.clientWidth;
    track.scrollTo({ left: pages > 1 ? (maxScroll / (pages - 1)) * index : 0, behavior: 'smooth' });
  }

  function updateActiveDot() {
    const dots = dotsWrap.querySelectorAll('.an-carousel-dot');
    if (!dots.length) return;
    const maxScroll = track.scrollWidth - track.clientWidth;
    const progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
    const active = Math.round(progress * (dots.length - 1));
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
  }

  function buildDots() {
    const pages = getPages();
    dotsWrap.innerHTML = '';
    if (pages <= 1) {
      dotsWrap.hidden = true;
      return;
    }
    dotsWrap.hidden = false;
    for (let i = 0; i < pages; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'an-carousel-dot';
      dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
      dot.addEventListener('click', () => scrollToPage(i, pages));
      dotsWrap.appendChild(dot);
    }
    updateActiveDot();
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(buildDots, 150);
  });
  track.addEventListener('scroll', () => window.requestAnimationFrame(updateActiveDot), { passive: true });

  buildDots();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-an-reviews-ticker]').forEach((ticker) => {
  const track = ticker.querySelector('[data-an-reviews-ticker-track]');
  if (!track) return;
  const cards = Array.from(track.children);
  const total = cards.length / 2;
  if (!total || !Number.isInteger(total)) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    cards.slice(total).forEach((card) => card.remove());
    return;
  }

  // Start a couple of cards in, so there's already content filling the
  // left side on first paint instead of empty space next to the first
  // centered card. Clamped in case there are only a couple of reviews.
  let index = Math.min(2, total - 1);
  let paused = false;

  // Positions the track so cards[index] sits exactly in the horizontal
  // middle of the ticker — not "scroll left by N cards and hope a card
  // lands near the middle" (that leaves uneven overflow on each side and
  // the "centered" card ends up off-center). offsetWidth is the
  // untransformed layout width, since the active card carries a scale()
  // transform that would otherwise throw this off.
  function render(withTransition) {
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
    const cardWidth = cards[0].offsetWidth;
    const step = cardWidth + gap;
    const offset = (ticker.clientWidth / 2) - (cardWidth / 2) - (index * step);
    track.style.transition = withTransition ? 'transform 0.7s ease' : 'none';
    track.style.transform = 'translateX(' + offset + 'px)';
    cards.forEach((card, i) => card.classList.toggle('is-center', i === index));
  }

  function advance() {
    if (paused) return;
    index++;
    render(true);
    if (index >= total) {
      window.setTimeout(() => {
        index = 0;
        render(false);
      }, 700);
    }
  }

  ticker.addEventListener('mouseenter', () => { paused = true; });
  ticker.addEventListener('mouseleave', () => { paused = false; });
  window.addEventListener('resize', () => render(false));

  render(false);
  setInterval(advance, 5000);
});

  } catch(e) { console.error(e); }
})();
})();
